import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID,
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdAction,
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureAction,
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/trialInstitutionItemCategory";
import { trialInstitutionItemCategoryApi } from 'src/services/trialInstitutionItemCategory';

export const
    getTrialInstitutionItemCategoriesByTrialInstitutionIdEpic = (action$): 
    Observable<ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessAction | ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID)
            .mergeMap((action: ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdAction) => {
                return trialInstitutionItemCategoryApi
                    .getTrialInstitutionItemCategoriesByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemCategories, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }